import type { ColumnStoryblok } from "~/generated/sb/blok-types";

export const isOnlyMedia = (left?: ColumnStoryblok, right?: ColumnStoryblok) => {
	const mediaTypes = ["media", "mediaCard", "taggedImage"] as const;
	const l = left?.content?.every((b) =>
		mediaTypes.includes(b.component as (typeof mediaTypes)[number]),
	);
	const r = right?.content?.every((b) =>
		mediaTypes.includes(b.component as (typeof mediaTypes)[number]),
	);
	return (l && r) ?? false;
};
